import type { LinkedAccount, LinkedAccountPlatform } from "@store/linkedAccountSlice";
import { LinkedAccountCard } from "./LinkedAccountCard/LinkedAccountCard";

interface LinkedAccountsGridProps {
  accounts: LinkedAccount[];
  platform: LinkedAccountPlatform;
}

export const LinkedAccountsGrid = ({ accounts, platform }: LinkedAccountsGridProps) => {
  return (
    <div className="grid w-full grid-cols-2 gap-[12px]">
      {accounts.map((account, index) => (
        <LinkedAccountCard key={account.id ?? `${platform}-${account.accountId}-${index}`} account={account} />
      ))}
    </div>
  );
};
